var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.selectedChat
    ? _c(
        "div",
        { attrs: { id: "team-summary-chat" } },
        [
          _c(
            "div",
            { staticClass: "head" },
            [
              [
                _c(
                  "a-dropdown",
                  {
                    attrs: { trigger: ["click"] },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                { attrs: { id: "dropdown-menu" } },
                                [
                                  _c(
                                    "a-menu-item",
                                    { key: "0", staticClass: "menu-item" },
                                    [
                                      _c("input", {
                                        staticClass: "change-pp-class",
                                        attrs: {
                                          id: "change-pp",
                                          type: "file",
                                          accept:
                                            "image/png, image/jpeg, image/gif",
                                        },
                                        on: { change: _vm.uploadFile },
                                      }),
                                      _vm._v(" "),
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      )
                                        ? _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.changePhoto"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.addPhoto")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        { key: "1", staticClass: "menu-item" },
                                        [
                                          _c(
                                            "a",
                                            { on: { click: _vm.showViewer } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.seePhoto")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c("a-menu-divider")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        {
                                          key: "2",
                                          staticClass: "menu-item",
                                          attrs: { id: "delete-option" },
                                          on: { click: _vm.deleteProfilePhoto },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.deletePhoto")
                                            ) + "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2059247843
                    ),
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "ant-dropdown-link",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "label",
                          { staticClass: "imgUpload" },
                          [
                            _vm.groupProfilePicture ||
                            _vm.$_.get(
                              _vm.selectedChat,
                              "meta.groupThread.groupProfilePicture"
                            )
                              ? _c("a-avatar", {
                                  attrs: {
                                    id: "team-summery-avatar",
                                    src:
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      ),
                                    size: 84,
                                  },
                                })
                              : _c(
                                  "div",
                                  { attrs: { id: "team-chat-container" } },
                                  [
                                    _c("TeamChatIcon", {
                                      attrs: { id: "team-chat-icon" },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  attrs: {
                    id: "groupViewerModal",
                    visible: _vm.isImageViewerShow,
                    footer: false,
                  },
                  on: { cancel: _vm.closeViewer },
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.groupProfilePicture ||
                        _vm.$_.get(
                          _vm.selectedChat,
                          "meta.groupThread.groupProfilePicture"
                        ),
                    },
                  }),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user-name" }, [_vm._v(_vm._s("TEAM"))]),
          _vm._v(" "),
          _vm.mediaSlideVisible
            ? _c("MediaSlide", {
                staticClass: "team-chat-media-area",
                on: {
                  "close-media-slide": function ($event) {
                    _vm.mediaSlideVisible = false
                  },
                },
              })
            : _c("div", { staticClass: "user-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "media-row",
                    on: {
                      click: function ($event) {
                        _vm.mediaSlideVisible = true
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "media-text" }, [
                      _vm._v(" " + _vm._s(_vm.$t("message.sumChat_MediaFile"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "material-icons media-btn" }, [
                      _vm._v("arrow_forward"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "user-info-head" }, [
                  _vm._v(_vm._s(_vm.$t("message.userInformations"))),
                ]),
                _vm._v(" "),
                _vm.onlineUserList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "user-list" },
                      [
                        _vm.offlineUserList.length > 0
                          ? _c("p", { attrs: { id: "online-users-label" } }, [
                              _vm._v(_vm._s(_vm.$t("message.online"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.onlineUserList, function (user) {
                          return _c(
                            "div",
                            { staticStyle: { "margin-top": "10px" } },
                            [
                              _c("div", { staticClass: "team-user-info" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "team-user-item",
                                    on: {
                                      click: function (e) {
                                        e.preventDefault()
                                        user.userDetailVisible =
                                          !user.userDetailVisible
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "avatarContainer team-agents-avatar",
                                      },
                                      [
                                        _c("AgentAvatar", {
                                          attrs: {
                                            "user-i-d": user._id,
                                            size: 30,
                                            "font-size": 14,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "nameContainer" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "tooltip-container",
                                            attrs: { title: user.name },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(user.name) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons dm-message-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.directMessage(user)
                                      },
                                    },
                                  },
                                  [_vm._v("message")]
                                ),
                              ]),
                              _vm._v(" "),
                              user.userDetailVisible
                                ? _c(
                                    "div",
                                    _vm._l(_vm.datas, function (data) {
                                      return _c(
                                        "div",
                                        { staticClass: "agent-item-detail" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              attrs: { id: "poped-icons" },
                                            },
                                            [_vm._v(_vm._s(data.icon))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "poped_datas",
                                              attrs: {
                                                title:
                                                  data.slot === "email"
                                                    ? user[data.slot]
                                                    : null,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(user[data.slot]) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.offlineUserList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "user-list" },
                      [
                        _vm.onlineUserList.length > 0
                          ? _c("p", { attrs: { id: "offline-users-label" } }, [
                              _vm._v(_vm._s(_vm.$t("message.offline"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.offlineUserList, function (user) {
                          return _c(
                            "div",
                            { staticStyle: { "margin-top": "10px" } },
                            [
                              _c("div", { staticClass: "team-user-info" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "team-user-item",
                                    on: {
                                      click: function (e) {
                                        e.preventDefault()
                                        user.userDetailVisible =
                                          !user.userDetailVisible
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "avatarContainer team-agents-avatar",
                                      },
                                      [
                                        _c("AgentAvatar", {
                                          attrs: {
                                            "user-i-d": user._id,
                                            size: 30,
                                            "font-size": 14,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "nameContainer" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "tooltip-container",
                                            attrs: { title: user.name },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(user.name) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons dm-message-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.directMessage(user)
                                      },
                                    },
                                  },
                                  [_vm._v("message")]
                                ),
                              ]),
                              _vm._v(" "),
                              user.userDetailVisible
                                ? _c(
                                    "div",
                                    _vm._l(_vm.datas, function (data) {
                                      return _c(
                                        "div",
                                        { staticClass: "agent-item-detail" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              attrs: { id: "poped-icons" },
                                            },
                                            [_vm._v(_vm._s(data.icon))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "poped_datas",
                                              attrs: {
                                                title:
                                                  data.slot === "email"
                                                    ? user[data.slot]
                                                    : null,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(user[data.slot]) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }